import { render, staticRenderFns } from "./StaleBanner.vue?vue&type=template&id=7bb4a50a&scoped=true"
import script from "./StaleBanner.vue?vue&type=script&lang=js"
export * from "./StaleBanner.vue?vue&type=script&lang=js"
import style0 from "./StaleBanner.vue?vue&type=style&index=0&id=7bb4a50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb4a50a",
  null
  
)

export default component.exports